import { mmFetchWithResponse } from './mmFetchWithResponse';

class CycleCountApi {
    constructor() {
        this.baseUrl = 'api/cycle-count/v1/';
    }

    async createReplenishmentLocationCycleCountRequest(facilityID, locationId) {
        const url = `${this.baseUrl}request/replenishment`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ facilityID, locationId }),
        });
    }

    async getIncompleteReplenishmentLocationCycleCountRequests(facilityID) {
        const url = `${this.baseUrl}request/replenishment?facilityID=${facilityID}`;
        return mmFetchWithResponse(url);
    }

    async getPartnerCycleCountRequests(facilityID) {
        const url = `${this.baseUrl}request/partner?facilityID=${facilityID}&includeComplete=true`;
        return mmFetchWithResponse(url);
    }

    async createSkuCycleCountRequest(externalSkus, packagingIds, facilityID) {
        const url = `${this.baseUrl}request/sku`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ externalSkus, facilityID, packagingIds }),
        });
    }

    async createPartnerCycleCountRequest(facilityID, companySources, overrideExisting = false) {
        const url = `${this.baseUrl}request/partner`;
        const body = {
            facilityID,
            companySources,
            overrideExisting: overrideExisting === true,
        };
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(body),
        });
    }

    async getSkuOptions(facilityID) {
        const url = `${this.baseUrl}skus?facilityID=${facilityID}`;
        return mmFetchWithResponse(url);
    }

    async cancelCycleCountRequest(requestId) {
        const url = `${this.baseUrl}request/${requestId}/cancel`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
        });
    }

    async getLocationCycleCountResults(
        facilityID,
        start,
        end,
        sources = [],
        showIncomplete = false,
        excludeReplenishment = false,
    ) {
        let url = `${this.baseUrl}results/location?facilityID=${facilityID}&start=${start}&end=${end}`;
        if (sources.length > 0) {
            sources.forEach((source) => {
                url += `&sources[]=${encodeURIComponent(source)}`;
            });
        }
        if (showIncomplete) {
            url += `&includeIncomplete=${showIncomplete}`;
        }
        if (excludeReplenishment) {
            url += `&excludeReplenishment=${excludeReplenishment}`;
        }
        return mmFetchWithResponse(url);
    }

    async excludeFromCycleCountResults(requestEntityID) {
        const url = `${this.baseUrl}requestEntity/${requestEntityID}/exclude`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
        });
    }

    async getLocationIssues(facilityID, sources = []) {
        let url = `${this.baseUrl}results/location/issues?facilityID=${facilityID}`;
        if (sources.length > 0) {
            sources.forEach((source) => {
                url += `&sources[]=${encodeURIComponent(source)}`;
            });
        }
        return mmFetchWithResponse(url);
    }

    async resolveIssue(eventID, inventorySummaryEventID = null) {
        const url = `${this.baseUrl}results/location/issues`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ eventID, inventorySummaryEventID }),
        });
    }

    async getSkuCycleCountResults(facilityID, sources = []) {
        let url = `${this.baseUrl}results/sku?facilityID=${facilityID}`;
        if (sources.length > 0) {
            sources.forEach((source) => {
                url += `&sources[]=${encodeURIComponent(source)}`;
            });
        }
        return mmFetchWithResponse(url);
    }

    async getSkuCycleCountRequestEntityResults(requestEntityID) {
        const url = `${this.baseUrl}results/sku/${requestEntityID}`;
        return mmFetchWithResponse(url);
    }

    async getPartnerCycleCountDetails(requestId) {
        const url = `${this.baseUrl}results/partner/${requestId}`;
        return mmFetchWithResponse(url);
    }
}

export { CycleCountApi };
